<template>
	<div class="vesupplierList">
		<div class="filters">
			<el-form :inline="true" :model="form">
				<!-- 供应商名称input -->
				<el-form-item>
					<el-input placeholder="请输入供应商名称" v-model="form.supplierName"></el-input>
				</el-form-item>
				<el-form-item>
					<el-select v-model="form.supplierGenre">
						<el-option key label="请选择供应商类型" value=""></el-option>
						<el-option v-for="(item,index) in supplierGenreList" :key="index" :value="item.value" :label="item.name">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="form.businessType">
						<el-option key label="请选择业务类型" value=""></el-option>
						<el-option v-for="(item,index) in businessTypeList" :key="index" :value="item.value" :label="item.name">
						</el-option>
					</el-select>
				</el-form-item>
				<el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
			</el-form>
		</div>
		<div>
			<el-card>
				<el-button type="primary" slot="header" @click="add()">新增供应商</el-button>
				<el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName"
					@selection-change="handleSelectionChange"
					:height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109">
					<el-table-column type="selection" width="55" v-if="venueManagecheckbox"></el-table-column>
					<el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
					</el-table-column>
					<el-table-column prop="supplierName" label="名称">
					</el-table-column>
					<el-table-column prop="supplierGenre" label="供应商类型">
						<template slot-scope="scope">
							<span v-if="scope.row.supplierGenre == 1">企业</span>
							<span v-if="scope.row.supplierGenre == 2">个体户</span>
						</template>
					</el-table-column>
					<el-table-column prop="businessType" label="业务类型">
						<template slot-scope="scope">
							<span v-if="scope.row.businessType == 1">用房租赁</span>
							<span v-if="scope.row.businessType == 2">信号基站</span>
							<span v-if="scope.row.businessType == 3">网络接入</span>
							<span v-if="scope.row.businessType == 4">快递柜</span>
							<span v-if="scope.row.businessType == 5">售货机</span>
							<span v-if="scope.row.businessType == 6">商业摆展</span>
							<span v-if="scope.row.businessType == 7">废品收回</span>
							<span v-if="scope.row.businessType == 8">电梯广告</span>
							<span v-if="scope.row.businessType == 9">道闸广告</span>
							<span v-if="scope.row.businessType == 10">行人门广告</span>
							<span v-if="scope.row.businessType == 11">灯箱广告</span>
							<span v-if="scope.row.businessType == 12">转售能源</span>
							<span v-if="scope.row.businessType == 13">代收缴服务</span>
							<span v-if="scope.row.businessType == 14">场地类其他</span>
							<span v-if="scope.row.businessType == 15">美邻商城</span>
						</template>
					</el-table-column>
					<el-table-column prop="contactName" label="负责人">
					</el-table-column>
					<el-table-column prop="contactNumber" label="电话">
					</el-table-column>
					<el-table-column prop="supplierMailAddress" label="通讯地址">
					</el-table-column>
					<el-table-column prop="remark" label="备注" width="300px">
						<template slot-scope="scope">
							<el-tooltip placement="top" effect="light"
								v-if="scope.row.remark&&scope.row.remark.length> require('@/config/enum').tableDatamaxlength15"
								:disabled="false">
								<div slot="content">
									<span>{{ scope.row.remark }}</span>
								</div>
								<div class="conctentstyle">
									{{ scope.row.remark.substring(0, require('@/config/enum').tableDatamaxlength15) | valueIsNull }}
									<span v-if="scope.row.remark.length>require('@/config/enum').tableDatamaxlength15">...</span>
								</div>
							</el-tooltip>
							<el-tooltip placement="top" effect="light" v-else :disabled="true">
								<div class="conctentstyle">{{ scope.row.remark | valueIsNull }}</div>
							</el-tooltip>
						</template>
					</el-table-column>
					<el-table-column :label="$t('lang.lab_operation')" fixed="right" :width="require('@/config/enum').opr_width3">
						<template slot-scope="scope">
							<el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
							<el-button class="orange" @click="deleteOne(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
					:page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
					:page-count="pageCount" />
			</el-card>
		</div>
	</div>
</template>

<script>
	export default {
		name: '/manage/main.venueList',
		data() {
			return {
				pageCount: 0, // 总页数
				pageNo: 1, // 页数
				pageSize: 10, // 每页显示数量
				multipleSelection: [], // 多选框
				venueManagecheckbox: require('@/config/enum').venueManagecheckbox, // 是否隐藏复选框
				tableData: [], // 列表数据
				form: {
					supplierName: '',
					supplierGenre: '',
					businessType: '',
				},
				supplierGenreList: [{
					value: '1',
					name: '企业'
				}, {
					value: '2',
					name: '个体户'
				}],
				businessTypeList: [{
					value: '1',
					name: '用房租赁'
				}, {
					value: '2',
					name: '信号基站'
				}, {
					value: '3',
					name: '网络接入'
				}, {
					value: '4',
					name: '快递柜'
				}, {
					value: '5',
					name: '售货机'
				}, {
					value: '6',
					name: '商业摆展'
				}, {
					value: '7',
					name: '废品收回'
				}, {
					value: '8',
					name: '电梯广告'
				}, {
					value: '9',
					name: '道闸广告'
				}, {
					value: '10',
					name: '行人门广告'
				}, {
					value: '11',
					name: '灯箱广告'
				}, {
					value: '12',
					name: '转售能源'
				}, {
					value: '13',
					name: '代收缴服务'
				}, {
					value: '14',
					name: '场地类其他'
				}, {
					value: '15',
					name: '美邻商城'
				}],
			}
		},
		watch: {

		},
		created() {
			// this.gardenId = this.$store.getters.gardenId
			this.getData()
		},
		activated() {
			this.getData()
		},
		methods: {
			getData() {
				let loading = this.$loading()
				let url = `/venueSupplier?supplierName=${this.form.supplierName}&supplierGenre=${this.form.supplierGenre}&businessType=${this.form.businessType}&pageSize=${this.pageSize}&pageNo=${this.pageNo}&gardenId=${this.$store.getters.gardenId}`
				this.$get(url)
					.then(res => {
							loading.close()
							console.log(res)
							this.tableData = res.list
							this.pageCount = res.pageCount
						},
						error => {
							loading.close()
							this.$message.error(error)
						})
			},
			// 新增
			add() {
				window.localStorage.setItem('vesupplierForm', '')
				this.$router.push({
					name: 'vesupplierAdd',
					query: {
						flag: true
					}
				})
			},
			// 编辑
			edit(rowData) {
				window.localStorage.setItem('vesupplierForm', '')
				console.log(rowData)
				this.$router.push({
					name: 'vesupplierAdd',
					query: {
						flag: false,
						object: rowData,
					}
				})
			},
			// 删除
			deleteOne(id) {
				let loading = this.$loading()
				this.$confirm(this.$i18n.t('lang.lab_isdelete'), this.$i18n.t('lang.lab_prompt'), {
						confirmButtonText: this.$i18n.t('lang.btn_confirm'),
						cancelButtonText: this.$i18n.t('lang.btn_cancel'),
						type: 'warning'
					}).then(() => {
						this.$delete(`/venueSupplier/` + id).then(
							res => {
								loading.close()
								if (res && res.errCode === 0) {
									this.$message({
										type: 'success',
										message: this.$i18n.t('lang.lab_del_success')
									})
									this.commit()
								}
							},
							error => {
								loading.close()
								this.$message.error(error)
							}
						)
					})
					.catch(() => {
						loading.close()
						this.$message({
							type: 'info',
							message: this.$i18n.t('lang.lab_del_can')
						})
					})
			},
			// 更新
			commit() {
				this.pageNo = 1
				this.getData()
			},
			// 表格斑马
			tableRowClassName({
				row,
				rowIndex
			}) {
				return rowIndex % 2 === 0 ? 'row-dark' : ''
			},
			// 多选框
			handleSelectionChange(val) {
				this.multipleSelection = val
			},
			// 翻页
			handleCurrentChange(val) {
				this.pageNo = val
				this.getData()
			},
			// 切换每页显示多少数据
			handleSizeChange(val) {
				this.pageNo = 1
				this.pageSize = val
				this.getData()
			},
			// ID序号功能
			indexMethod(index) {
				return (this.pageNo - 1) * this.pageSize + index + 1
			},
		}
	}
</script>

<style lang="scss">
.vesupplierList{
	.conctentstyle {
		/* color: #4a88b0; */
	}
	.el-tooltip__popper.is-light {
    max-width: 500px;
  }
}
	
</style>